"use client";

import { useEffect } from "react";

export default function RedirectComponent() {
    useEffect(() => {
        window.location.href = "/";
    }, []);
    return (
        <div></div>
    )
};